import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { InputBoxModule } from 'app/shared/components/input-box/input-box.module';
import { ModalModule } from 'app/shared/components/modal/modal.module';
import { SelectBoxModule } from 'app/shared/components/select-box/select-box.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { LocalizationFilterFormComponent } from './localization-filter-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SelectBoxModule,
    InputBoxModule,
    ButtonModule,
    ModalModule,
    PipesModule,
  ],
  declarations: [LocalizationFilterFormComponent],
  exports: [LocalizationFilterFormComponent],
})
export class LocalizationFilterFormModule {}
